import { useQuery } from '@tanstack/react-query'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import PendingRequestsDataGrid from 'src/components/PendingRequestsDataGrid/PendingRequestsDataGrid'
import { VirtualCardListModel } from 'src/models/virtualCard.models'
import {
  isCardApprovalRuleEnabled,
  orgCardApprovalRulesQueries,
} from 'src/queries/organizations/cardApprovalRules/cardApprovalRules.queries'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'

interface PendingRequestsTableProps {
  virtualCards: VirtualCardListModel[]
}

const PendingRequestsTable: React.FC<PendingRequestsTableProps> = (props) => {
  const isEmpty = props.virtualCards.length === 0
  const user = useSelector(selectUserListModelFromState)
  const { data: cardApprovalRules } = useQuery(
    orgCardApprovalRulesQueries.detail(user?.organizationId),
  )
  const cardApprovalsEnabled = isCardApprovalRuleEnabled(cardApprovalRules)

  const [clientHeight, setClientHeight] = useState<number | null>(null)
  const ref: React.MutableRefObject<HTMLDivElement | null> = useRef(null)

  const [viewportHeight, setViewportHeight] = useState({
    height: window.innerHeight,
  })

  const updateWindowSize = (): void => {
    setViewportHeight({ height: window.innerHeight })
  }

  useEffect(() => {
    setClientHeight(viewportHeight.height - 110)
  }, [ref?.current])

  useEffect(() => {
    window.addEventListener('resize', updateWindowSize)
    setClientHeight(viewportHeight.height - 110)
    return (): void => {
      window.removeEventListener('resize', updateWindowSize)
    }
  }, [viewportHeight, ref?.current])

  return (
    <div>
      {!isEmpty && (
        <PendingRequestsDataGrid
          virtualCards={props.virtualCards}
          cardApprovalRuleEnabled={cardApprovalsEnabled}
          cardApprovalRules={cardApprovalRules}
          clientHeight={clientHeight || 0}
        />
      )}
    </div>
  )
}

export default PendingRequestsTable
